import api from './api';

const endpoint = '/api/v1/ecommerce/cart';

const paymentsTodayEndpoint = `${endpoint}/paymentstoday`;
export default {
    async get() {
        return await api.get(endpoint);
    },

    add(productSlug, options, price, quantity) {
        return api.post(endpoint, {
            productSlug: productSlug,
            options: options,
            price: price,
            quantity: quantity,
        });
    },

    quickAdd(productSlug, options) {
        return this.add(productSlug, options, null, null);
    },

    async updateItem(itemId, price, quantity) {
        return await api.patch(`${endpoint}/${itemId}`, {
            price: price,
            quantity: quantity,
        });
    },

    async deleteItem(itemId) {
        return await api.delete(`${endpoint}/${itemId}`);
    },
    
    async getPaymentsToday() {
        return await api.get(paymentsTodayEndpoint);
    },
    
    async setPaymentsToday(paymentsToday) {
        return await api.post(paymentsTodayEndpoint, {
            paymentsToday,
        });
    },
    
}
